import generateAsyncActions from 'utils/generateAsyncActions';
import alt from 'components/Dispatcher';
import DefaultTriggerTagSource from 'sources/triggers/DefaultTriggerTagSource';

class DefaultTriggerTagActions {
  constructor() {
    this.generateActions(...generateAsyncActions('fetchDefaultTriggerTags'));
  }

  fetchDefaultTriggerTags() {
    return dispatch => {
      dispatch();
      return DefaultTriggerTagSource.fetchDefaultTriggerTags().then(
        this.fetchDefaultTriggerTagsSuccess,
        this.fetchDefaultTriggerTagsError
      );
    };
  }
}

export default alt.createActions(DefaultTriggerTagActions);
